import { Descriptions } from "antd";
import React from "react";
import  './style.scss';

export const Testimonial = (props) => {
    return(
        <div className="testimonial-container">
         
                 <div className="title">
                        {props.title}
                    </div>
                <div className="centerSection">
                   <div className="description">
                        {props.description}

                        </div>
                </div>
                <div className="nameof">
                  {props.nameof}
               
                </div>
          
            </div>
        
           )
}
